import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiTabs = {
  defaultProps: {},
  styleOverrides: {
    root: {
      ".MuiTabs-indicator": {
        height: 4
      }
    }
  }
};
const MuiTab = {
  defaultProps: {
    disableFocusRipple: true
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
      fontSize: capitalDesignTokens.foundations.typography.fontSize.h5,
      margin: theme.spacing(0, 0.5),
      minWidth: 0,
      padding: theme.spacing(1, 1),
      lineHeight: 2,
      minHeight: "unset",
      "&.Mui-selected": {
        color: theme.palette.primary.dark,
        ".MuiChip-root": {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.dark
        }
      },
      "&:hover, &.Mui-hover": {
        background: theme.palette.action.hover
      },
      "&.Mui-focusVisible, &:focus-visible": {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: "-2px",
        borderRadius: capitalDesignTokens.foundations.units.unitHalf,
        background: theme.palette.action.hover
      },
      "&.Mui-disabled": {
        color: theme.palette.text.disabled,
        ".MuiChip-root": {
          color: theme.palette.text.disabled,
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      ".MuiChip-root": {
        marginLeft: theme.spacing(0.5),
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.action.hover
      }
    })
  }
};
export {
  MuiTab,
  MuiTabs
};
//# sourceMappingURL=MuiTabs.js.map
